import {
  GET_DASHBOARD_CATEGORY_METRICS_FAIL,
  GET_DASHBOARD_CATEGORY_METRICS_IN_PROGRESS,
  GET_DASHBOARD_CATEGORY_METRICS_SUCCESS,
} from "../constants";

const createCategoryState = () => ({
  data: null,
  loading: false,
  error: false,
});

const initialState = {
  metricsByCategory: {
    interventions: createCategoryState(),
    containers: createCategoryState(),
    leak_detectors: createCategoryState(),
    pressure_gauges: createCategoryState(),
    scales: createCategoryState(),
    thermometers: createCategoryState(),
    installations_basic: createCategoryState(),
    installations_after_repair: createCategoryState(),
    installations_periodicity: createCategoryState(),
    trackdechets: createCategoryState(),
    service_providers: createCategoryState(),
  },
};

export default function dashboard(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_DASHBOARD_CATEGORY_METRICS_IN_PROGRESS: {
      const { category } = payload;
      if (!category || !state.metricsByCategory[category]) {
        return state;
      }
      return {
        ...state,
        metricsByCategory: {
          ...state.metricsByCategory,
          [category]: {
            data: null,
            loading: true,
            error: false,
          },
        },
      };
    }

    case GET_DASHBOARD_CATEGORY_METRICS_SUCCESS: {
      const { category, metrics } = payload;
      if (!category || !state.metricsByCategory[category]) {
        return state;
      }
      return {
        ...state,
        metricsByCategory: {
          ...state.metricsByCategory,
          [category]: {
            data: metrics,
            loading: false,
            error: false,
          },
        },
      };
    }

    case GET_DASHBOARD_CATEGORY_METRICS_FAIL: {
      const { category } = payload;
      if (!category || !state.metricsByCategory[category]) {
        return state;
      }
      return {
        ...state,
        metricsByCategory: {
          ...state.metricsByCategory,
          [category]: {
            data: null,
            loading: false,
            error: true,
          },
        },
      };
    }

    default:
      return state;
  }
}
